export default "__VITE_ASSET__CK7sk1MZ__"